import { ConnectedCalloutsList } from "components/ui/customWebviewer/shared/ConnectedCalloutsList/ConnectedCalloutsList"
import type { TEcall } from "types/elevationReferences.type"
import style from "./ConnectedCalloutsTab.module.scss"

const { tab, empty } = style

type Props = {
	ecalls: TEcall[]
	erefId: number | null
	onView: (ecall: TEcall) => void
}

export const ConnectedCalloutsTab = ({ ecalls, erefId, onView }: Props) => {
	if (ecalls.length === 0) {
		return <div className={empty}>No connected callouts</div>
	}

	return (
		<div className={tab}>
			<ConnectedCalloutsList ecalls={ecalls} showViewButton onEcallClick={onView} referenceLabelErefId={erefId} />
		</div>
	)
}
